import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const encodeObject = <T>(obj: T) => {
  return btoa(encodeURIComponent(JSON.stringify(obj)));
};

// Décoder l'objet à partir de Base64
export const decodeObject = <T>(encodedString: string | null): T | null => {
  if (!encodedString) {
    return null;
  }
  try {
    return JSON.parse(decodeURIComponent(atob(encodedString)));
  } catch (e) {
    return null;
  }
};

export const useJSONSearchParam = <T>(key: string, defaultValue: T): [T, (_: T) => void, () => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = decodeObject<T>(searchParams.get(key));

  const setValue = useCallback(
    (newValue: T) => {
      setSearchParams(params => {
        params.set(key, encodeObject(newValue));
        return params;
      });
    },
    [key, setSearchParams],
  );

  const deleteValue = useCallback(() => {
    setSearchParams(params => {
      params.delete(key);
      return params;
    });
  }, [key, setSearchParams]);

  return [value ?? defaultValue, setValue, deleteValue];
};
